module.exports = __webpack_public_path__ + "static/gruene_permeabilitaet-a09f6598151faff897974b97ba34527c.png";